import styled, { css } from 'styled-components';

interface ContentBlockProps {
  maxWidth?: string;
}

export const ContentBlock = styled.div<ContentBlockProps>`
  &.align-center {
    margin-left: auto;
    margin-right: auto;
  }

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `}
`;
